<h2 class="dialog-header">{{consts.TITLE_MAIN}}
    <mat-icon class="dialog-close-button" mat-dialog-close svgIcon="hub_close">
    </mat-icon>
</h2>
<div class="dialog-body">
    <form [formGroup]="editForm" #localForm="ngForm">
        <div class="announcements-dialog-content">
            <div class="row">
                <div class="col-12">
                    <label class="form-label form-label-required">
                        {{consts.LABLE_RECIPIENTS}}
                    </label>
                    <span *ngIf="editForm.get('team')?.invalid && localForm.submitted" class="required">
                        {{consts.LABEL_REQUIRED}}
                    </span>
                    <select class="form-element" formControlName="team">
                        <option value="">{{consts.PLACEHOLDER_RECIPIENTS}}</option>
                        <option *ngFor="let item of recipientList" value="{{item.lable}}">{{item.data?item.lable+item.data:item.lable}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label class="form-label">
                        {{consts.LABLE_DATE_RANGE}}
                    </label>
                    <span
                        *ngIf="editForm.get('startDateDatePart')?.valid && editForm.get('endDateDatePart')?.valid && !isDateRangeValid() && localForm.submitted"
                        class="required">
                        {{consts.LABLE_DATE_RANGE_INVALID}}
                    </span>
                </div>
                <div class="col-6">
                    <label class="form-label-second-level form-label-required">
                        {{consts.LABLE_FROM}}
                    </label>
                    <span *ngIf="editForm.get('startDateDatePart')?.invalid && localForm.submitted" class="required">
                        {{consts.LABEL_REQUIRED}}
                    </span>
                    <div class="row">
                        <div class="col">
                            <input type="date" class="form-element form-element-date"
                                formControlName="startDateDatePart" min="{{minDate| date: 'yyyy-MM-dd'}}"
                                max="{{maxDate| date: 'yyyy-MM-dd'}}"
                                placeholder="{{consts.PLACEHOLDER_ANNOUNCEMENT_TEXT}}">
                            <select class="form-element form-element-date" formControlName="startDateHourPart">
                                <option *ngFor="let item of hoursList" value="{{item}}">{{item}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <label class="form-label-second-level form-label-required">
                        {{consts.LABLE_TILL}}
                    </label>
                    <span *ngIf="editForm.get('endDateDatePart')?.invalid && localForm.submitted" class="required">
                        {{consts.LABEL_REQUIRED}}
                    </span>
                    <div class="row">
                        <div class="col">
                            <input type="date" class="form-element form-element-date" formControlName="endDateDatePart"
                                min="{{minDate| date: 'yyyy-MM-dd'}}" max="{{maxDate| date: 'yyyy-MM-dd'}}"
                                placeholder="{{consts.PLACEHOLDER_ANNOUNCEMENT_TEXT}}">
                            <select class="form-element form-element-date" formControlName="endDateHourPart">
                                <option *ngFor="let item of hoursList" value="{{item}}">{{item}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label class="form-label form-label-required">
                        {{consts.LABLE_ANNOUNCEMENT_TEXT}}
                    </label>
                    <span *ngIf="editForm.get('message')?.invalid && localForm.submitted" class="required">
                        <ng-container *ngIf="editForm.get('message')?.errors?.required">
                            {{consts.LABEL_REQUIRED}}
                        </ng-container>
                    </span>
                    <textarea class="message-text" formControlName="message"
                        placeholder="{{consts.PLACEHOLDER_ANNOUNCEMENT_TEXT}}" maxlength="128"></textarea>
                    <span class="message-remaning">{{editForm.get('message').value.length}}/128</span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label class="form-label">
                        {{consts.LABLE_LINK}}
                    </label>&nbsp;
                    <span class="text-secondary">(optional)</span>
                    <span *ngIf="editForm.get('link')?.invalid && localForm.submitted" class="required">
                        <ng-container *ngIf="editForm.get('link').value && editForm.get('link')?.errors?.invalidUrl">
                            {{consts.LABEL_EDIT_URL_INVALID}}
                        </ng-container>
                    </span>
                    <input matInput class="form-element" formControlName="link"
                        placeholder="{{consts.PLACEHOLDER_LINK}}" type="text">
                </div>
            </div>
            <div class="row" *ngIf="userPermission.isTopBanner">
                <div class="col-12">
                    <div class="top-banner-alert">
                        <mat-checkbox class="form-label" formControlName="isTopBanner">
                            {{consts.LABLE_TICK_TOP_BANNER}}
                        </mat-checkbox>
                        <span class="top-banner-massage-content">
                            {{consts.MESSAGE_TICK_TOP_BANNER}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col text-center">
                <button mat-button mat-dialog-close class="cancel-btn">
                    {{consts.BUTTON_CANCEL}}
                </button>
                <button mat-raised-button class="announcements-dialog-save-btn" (click)="sendAnnouncement()">
                    {{consts.BUTTON_SAVE}}
                </button>
            </div>
        </div>
    </form>
</div>